import React, { Component } from 'react';
import { Profile, Wrapper } from 'components';
import styled from 'react-emotion';
import _ from 'lodash';
import { Link } from 'gatsby';

const StyledPeople = styled.div`
    margin: 2rem 0 0.5rem 0;
    .team-subtitle:before {
        color: ${props => props.theme.colors.darkBlue};
        content: 'Hello! ';
    }
`;

const StyledPeopleGrid = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
`;

const StyledFilterOptions = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
`;

const StyledFilterOption = styled.li`
    display: inline-block;
    padding: 1rem;
    margin: 0 5px;
    width: auto;
    div {
        border-bottom: 1px solid ${props => (props.theme.colors.white)};
    }
    div:hover {
        cursor: pointer;
        border-bottom: 1px solid ${props => (props.theme.colors.darkBlue)};
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        margin: 0;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        margin: 0;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        font-size: 12px;
    }
    .active-filter {
        border-bottom: 1px solid ${props => (props.theme.colors.darkBlue)};
    }
`;

const StyledLink = styled(Link)`
    font-weight: 400;
    font-style: normal;
`;

const StyledButton = styled.button`
  color: ${props => props.theme.colors.black};
  background-color: ${props => props.theme.colors.white};
  padding: 10px 30px 10px 30px;
  border: 1px solid ${props => props.theme.colors.darkBlue};
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition-duration: ${props => props.theme.transitionDuration};
  transition-duration: ${props => props.theme.transitionDuration};
  transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  margin-bottom: 2rem;
  &:hover {
    background-color: ${props => props.theme.colors.darkBlue};
    color: ${props => props.theme.colors.white};
  }
`;

const filterOptions = [
    {
        text: 'Show All',
        key: null
    },
    {
        text: 'Leadership',
        key: 'Leadership'
    },
    {
        text: 'Designers',
        key: 'Designers'
    },
    {
        text: 'Developers',
        key: 'Developers'
    }   
]

class People extends Component {
    state = {
        selectedGroup: 'Leadership'
    }
    render() {
        const { profiles, limit } = this.props;
        const displayProfiles = profiles.edges.slice(0, limit);
        let profilePages;

        if (this.state.selectedGroup) {
            profilePages = _.sortBy(_.filter(displayProfiles, ['node.data.group.document[0].data.name.text', this.state.selectedGroup]), ['node.uid']).map((profile) => {
                return (
                    <Profile key={profile.node.uid} info={profile.node.data} />
                )
            })
        } else {
            profilePages = _.sortBy(displayProfiles, ['node.uid']).map((profile) => {
                return (
                    <Profile key={profile.node.uid} info={profile.node.data} />
                )
            })
        }

        const filterOptionList = filterOptions.map((option) =>
            <StyledFilterOption onClick={() =>
                this.setState({ selectedGroup: option.key })} key={option.key}>
                <div className={this.state.selectedGroup === option.key ? 'active-filter' : null}>
                    {option.text.toUpperCase()}
                </div>
            </StyledFilterOption>
        );

        const morePeopleButton = limit ? (<div style={{ width: '100%', textAlign: 'center' }}>
            <StyledLink to='/team'>
                <StyledButton>More people &rarr;</StyledButton>
            </StyledLink>
        </div>) : null;

        return (
            <Wrapper>
                <StyledPeople>
                    {/* <Title id='team'>MEET THE TEAM</Title> */}
                    {/* <h2 className='team-subtitle'>This is Us.</h2> */}
                    <h3>Our National Leadership Team</h3>
                    {/* <ScrollAnimation animateIn="fadeInUp" animateOnce={true} style={{ height: '100%' }}> */}
                    {/* <StyledFilterOptions>
                        {filterOptionList}
                    </StyledFilterOptions> */}
                    <StyledPeopleGrid>
                        {profilePages}
                    </StyledPeopleGrid>
                    {/* </ScrollAnimation> */}
                </StyledPeople>
                {/* {morePeopleButton} */}
            </Wrapper>
        );
    }
}

export default People;